import firebase from 'firebase'
import { useDocumentData } from 'react-firebase-hooks/firestore'

const options = {
    snapshotListenOptions: {
        includeMetadataChanges: true,
    },
}

const usePlantedTrees = () => {

    const [data, loading, error] = useDocumentData(
        firebase.firestore().doc('ngos/ngoWeForest'),
        options,
    )

    const plantedTress = (!error && !loading && data != null && !data.empty)
        ? Math.floor(data.currentPoints / data.donationUnitInPoints)
        : null

    return [error, loading, plantedTress]
}

export default usePlantedTrees
